import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Avatar } from '@udemy-v2/react-core-components';
import { ShowMore } from '@udemy-v2/react-reveal-components';
import { useI18n, RelativeDuration } from '@udemy-v2/i18n';
import styles from './instructor-response.module.scss';

// Define a basic type for the user prop (replace with actual type if available)
interface UserProfile {
  display_name: string;
  image_50x50: string;
  tracking_id: string;
  name: string;
  // Add other expected user properties if needed
}

// Define the props interface
export interface InstructorResponseProps {
  user?: UserProfile | null;
  content?: React.ReactNode | null;
  formattedTimestampSince?: string | null;
}
export const InstructorResponse: React.FC<InstructorResponseProps> = t0 => {
  const $ = _c(24);
  const {
    user: t1,
    content: t2,
    formattedTimestampSince: t3
  } = t0;
  const user = t1 === undefined ? null : t1;
  const content = t2 === undefined ? null : t2;
  const formattedTimestampSince = t3 === undefined ? null : t3;
  const {
    gettext
  } = useI18n();
  if (!user || !content) {
    return null;
  }
  let t4;
  if ($[0] !== user) {
    t4 = <Avatar data-purpose="avatar" user={user} srcKey="image_50x50" size="medium" alt="NONE" />;
    $[0] = user;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== user.display_name) {
    t5 = <p className={`ud-heading-md ${styles.name}`} data-purpose="instructor-name">{user.display_name}</p>;
    $[2] = user.display_name;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== gettext) {
    t6 = gettext("Instructor response");
    $[4] = gettext;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <span>{t6}</span>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== formattedTimestampSince) {
    t8 = formattedTimestampSince && <><span className={styles.dot}>{" \u2022 "}</span><span data-purpose="formatted-timestamp-since"><RelativeDuration datetime={formattedTimestampSince} /></span></>;
    $[8] = formattedTimestampSince;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <p className={`ud-text-sm ${styles["author-description"]}`}>{t7}{t8}</p>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t9) {
    t10 = <div className={styles["author-content"]}>{t5}{t9}</div>;
    $[13] = t5;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t4) {
    t11 = <div className={styles.author}>{t4}{t10}</div>;
    $[16] = t10;
    $[17] = t4;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== content) {
    t12 = <ShowMore collapsedHeight={100} withGradient={true} className={styles.body}><div className={styles.comment} data-purpose="content">{content}</div></ShowMore>;
    $[19] = content;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <div className={`ud-text-sm ${styles.response}`}>{t11}{t12}</div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};